import React, { useEffect, useRef, useState } from 'react';
import classes from './EditProfilePage2.module.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import SmallLoader from '../../component/SmallLoader';
import { FaTrash, FaUpload, FaArrowLeft } from 'react-icons/fa6';
import { getProfileApi, editProfileApi } from '../../http/http';
import Header2 from '../../component/NewComponents/Header2';
import { useTranslation } from 'react-i18next';

const EditProfilePage2 = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);
    const { userDetails } = useSelector((state) => state.persisted.userSlice);
    const navigate = useNavigate();

    const {t}=useTranslation();

    const [state, setState] = useState({
        name: "",
        image: "",
    });

    const [pickedImage, setPickedImage] = useState();
    const imageInput = useRef();

    function handlePickClick() {
        imageInput.current.click();
    }

    function handleImageChange(event) {
        const file = event.target.files[0];
        if (!file) {
            setPickedImage(null);
            return;
        }
        const fileReader = new FileReader();
        fileReader.onload = () => {
            setPickedImage(fileReader.result);
        };
        fileReader.readAsDataURL(file);
        setState(prevState => ({ ...prevState, image: file }));
    }

    const fetchUserProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfileApi(userDetails?.token);
            setProfile(response?.data);
            setState((prevValue) => ({ ...prevValue, name: response?.data?.name || t("190") }));
            setLoading(false);
        } catch (error) {
            toast.error(t("20"));
        }
    };

    useEffect(() => {
        if (userDetails?.token) {
            fetchUserProfile();
        }
    }, [userDetails]);

    const submitHandler = async (e) => {
        try {
            e.preventDefault();
            setSaveLoading(true);
            const formData = new FormData();
            formData.append("name", state?.name);
            if (state?.image) {
                formData.append("file", state?.image ?? null);
            }
            const result = await editProfileApi(formData, userDetails?.token);
            setSaveLoading(false);
            setPickedImage(null);
            toast.success(t("191"));
            fetchUserProfile();
        } catch (error) {
            toast.error(t("20"));
        }
    };

    return (
        <div className={classes.page}>
            <Header2 active={4} />

            <main className={classes.main}>

                {/* ── Hero bar ── */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>{t("164")}</span>
                        <h1 className={classes.heroTitle}>{t("59")} <em>{t("181")}</em></h1>
                    </div>
                    <button type="button" className={classes.backBtn} onClick={() => navigate(-1)}>
                        <FaArrowLeft className={classes.backIcon} />
                        {t("192")}
                    </button>
                </div>

                {/* ── Body ── */}
                {loading ? (
                    <div className={classes.loaderWrap}>
                        <SmallLoader />
                        <p className={classes.loaderText}>{t("193")}</p>
                    </div>
                ) : (
                    <form
                        onSubmit={submitHandler}
                        className={classes.formGrid}
                        encType="multipart/form-data"
                    >
                        {/* ── Left: Avatar panel ── */}
                        <div className={classes.avatarPanel}>
                            <div className={classes.panelLabel}>{t("194")}</div>

                            <div className={classes.avatarCard}>
                                <div className={classes.cardBg} />

                                <div className={classes.avatarWrap}>
                                    <img
                                        src={pickedImage || profile?.image || "/assets/images/avatar.png"}
                                        alt="profile pic"
                                        className={classes.avatarImg}
                                    />
                                    <button
                                        type="button"
                                        className={classes.trashBadge}
                                        onClick={() => {
                                            setPickedImage(null);
                                            setState(prev => ({ ...prev, image: "" }));
                                        }}
                                        title="Remove photo"
                                    >
                                        <FaTrash className={classes.trashIcon} />
                                    </button>
                                </div>

                                <div className={classes.avatarName}>
                                    {state.name || profile?.name || t("190")}
                                </div>
                                <div className={classes.avatarSub}>{t("195")}</div>

                                <input
                                    className={classes.hiddenInput}
                                    type="file"
                                    id="image"
                                    accept="image/png, image/jpeg"
                                    name="file"
                                    ref={imageInput}
                                    onChange={handleImageChange}
                                />
                                <button
                                    type="button"
                                    className={classes.uploadBtn}
                                    onClick={handlePickClick}
                                >
                                    <FaUpload className={classes.uploadIcon} />
                                    {t("196")}
                                </button>

                                {pickedImage && (
                                    <div className={classes.previewBadge}>
                                        {t("197")}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* ── Right: Fields panel ── */}
                        <div className={classes.fieldsPanel}>
                            <div className={classes.panelLabel}>{t("198")}</div>

                            <div className={classes.fieldsCard}>
                                <div className={classes.fieldGroup}>
                                    <label className={classes.fieldLabel} htmlFor="name">
                                        {t("199")}
                                    </label>
                                    <input
                                        id="name"
                                        type="text"
                                        className={classes.fieldInput}
                                        name="name"
                                        placeholder={t("200")}
                                        value={state.name}
                                        onChange={(event) => setState({ ...state, name: event.target.value })}
                                    />
                                </div>

                                <button
                                    className={classes.saveBtn}
                                    type="submit"
                                    disabled={saveLoading}
                                >
                                    {saveLoading ? (
                                        <span className={classes.savingDots}>{t("201")}<span>.</span><span>.</span><span>.</span></span>
                                    ) : (
                                        t("202")
                                    )}
                                </button>
                            </div>
                        </div>

                    </form>
                )}

            </main>
        </div>
    );
};

export default EditProfilePage2;